/**
 * Add Category to a model
 */

import { Category } from '@/store/modules/categories';
import Application from '../application';
import SVG from 'svg.js';

export type CategoryRequirements = {
  app: Application;
  attributes: Record<string, any>;
  shape: SVG.Shape;
};

export const CategoryMixin = <T extends { new (...args: any[]): CategoryRequirements }>(base: T) => {
  return class CategoryMixin extends base {
    _category: Category | null | undefined = null;
    isInside = false;

    get category() {
      return this._category || (this._category = this.app.getCategoryObj(this.categoryId));
    }

    set category(category) {
      this.categoryId = category?.id ?? null;
    }

    get categoryId() {
      return this.attributes.categoryId as number | null | undefined;
    }

    set categoryId(categoryId: number | null | undefined) {
      if (!categoryId) {
        delete this.attributes.categoryId;
        this.removeCategoryColor();
      } else {
        this.attributes.categoryId = categoryId;
        if (!this.isInside) {
          this.applyCategoryColor(this.app.getCategoryColor(categoryId));
        }
      }
      delete this._category;
    }

    applyCategoryColor(color: string | null) {
      if (this.shape) {
        this.shape.style('fill', color);
      }
    }

    removeCategoryColor() {
      this.shape?.style('fill', null);
    }
  };
};
